<template>
  <b-modal
    ref="modal"
    v-model="isShown"
    @ok.prevent="rescheduleAndClose(editCopy)"
    @hide="reset"
    static
  >
    <template #modal-title>
      <div class="eng/deu">Reschedule appointment</div>
      <div class="arabic">تأجيل الموعد</div>
    </template>

    <div class="errors">
      <div class="eng/deu" v-show="schedulingConflicts">
        The appointment coincides with another one, that was entered earlier.
      </div>
      <div class="arabic" v-show="schedulingConflicts">
        لسوء الحظ ، يتعارض الموعد مع موعد أخر تم إنشاؤه مسبقاً.
      </div>
    </div>

    <b-form v-if="editCopy">
      <b-form-group>
        <template #label>
          <div class="eng/deu">Begin</div>
          <div class="arabic">البداية</div>
        </template>
        <date-picker
          v-model="startsAt"
          lang="de"
          type="datetime"
          width="100%"
          input-class="form-control"
          format="DD.MM.YYYY HH:mm"
          :time-picker-options="{
            start: '07:00',
            step: '00:15',
            end: '20:00',
          }"
        ></date-picker>
      </b-form-group>
      <b-form-group>
        <template #label>
          <div class="eng/deu">End</div>
          <div class="arabic">النهاية</div>
        </template>
        <date-picker
          v-model="endsAt"
          lang="de"
          type="datetime"
          width="100%"
          input-class="form-control"
          format="DD.MM.YYYY HH:mm"
          :time-picker-options="{
            start: '08:00',
            step: '00:15',
            end: '22:00',
          }"
        ></date-picker>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DatePicker from 'vue2-datepicker'

import { Offer } from '@/store/interview/offers/types'
import { Mutation } from '@/store/interview/offers/mutations'
import Editor from '@/components/artifacts/Editor.vue'
import EditorMixin from '@/components/artifacts/EditorMixin'
import FetchErrorMixin from '@/components/mixins/fetchErrors'

export default Vue.extend({
  mixins: [EditorMixin, FetchErrorMixin],
  components: { DatePicker },
  computed: {
    startsAt: {
      get() {
        if (this.editCopy) {
          return new Date(this.editCopy.timeSlot.start.value)
        } else {
          return null
        }
      },
      set(value) {
        if (this.editCopy) {
          this.editCopy.timeSlot.start.value = value.toISOString()
        } else {
          throw new Error('no editCopy to save startsAt')
        }
      },
    },
    endsAt: {
      get() {
        if (this.editCopy) {
          return new Date(this.editCopy.timeSlot.end.value)
        } else {
          return null
        }
      },
      set(value) {
        if (this.editCopy) {
          this.editCopy.timeSlot.end.value = value.toISOString()
        } else {
          throw new Error('no editCopy to save endsAt')
        }
      },
    },
    isShown: {
      get() {
        return this.value !== null
      },
      set(value) {
        if (value == false) {
          this.stopToEdit()
          this.makeEditCopy()
        }
      },
    },
  },
  methods: {
    ...mapActions('interview/offers', ['reschedule']),
    ...mapMutations('interview/offers', ['stopToEdit']),
    rescheduleAndClose(offer) {
      this.reset()
      this.reschedule({
        offer,
        onError: (e) => {
          if (e.errcode == '23P01') {
            return this.catchError(e)
          } else {
            throw e
          }
        },
      }).then(() => {
        if (!this.hasErrors) {
          this.$refs.modal.hide()
        }
      })
    },
    suggestNewEnd(newValue) {
      const start = new Date(this.value.timeSlot.start.value)
      const end = new Date(this.value.timeSlot.end.value)
      const duration = end.getTime() - start.getTime()
      const newStart = new Date(this.editCopy.timeSlot.start.value)

      this.editCopy.timeSlot.end.value = new Date(newStart.getTime() + duration).toISOString()
    },
  },
  watch: {
    startsAt(newDate, oldDate) {
      if (newDate && oldDate) {
        const difference = newDate.getTime() - oldDate.getTime()
        this.endsAt = new Date(this.endsAt.getTime() + difference)
      }
    },
  },
})
</script>
